export default __webpack_public_path__ + "static/media/blog-img237.f1dbe208.jpg";